var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const requestHasBody_1 = __importDefault(require("./requestHasBody"));
const generateQueryString_1 = __importDefault(require("./generateQueryString"));
const getOrigin_1 = __importDefault(require("./getOrigin"));
function generateUrl(requestOptions) {
    const { action, route, data } = requestOptions;
    const { includeTime } = requestOptions.requestOptions || {};
    const origin = (0, getOrigin_1.default)(requestOptions);
    let url = origin + '/' + route;
    if (!(0, requestHasBody_1.default)(action)) {
        url = url + (0, generateQueryString_1.default)(data, includeTime);
    }
    if (url.length > 2048) {
        console.warn(`The generated URL is potentially too long. Maximum compatibility with different clients/servers requires staying under 2KB, although in practice these days it should largely work up to at least 2MB if not more.
      The current URL is ${url.length} characters long: ${url}
      You should consider switching to a POST request if you cannot ensure the url will be shorter.`);
    }
    return url;
}
exports.default = generateUrl;
//# sourceMappingURL=generateUrl.js.map